import { Box, Stack, Typography, useTheme } from "@mui/material";
import MarketplaceConnectorImage from "@features/connections/generic/components/MarketplaceConnectorImage";
import { Connector } from "@domain/connection/models/Connector";
import { Icon } from "@shared/icons";

interface ConnectionSetupHeaderProps {
    connector: Connector;
}

const ConnectionSetupHeader = ({ connector }: ConnectionSetupHeaderProps) => {
    const theme = useTheme();
    const colors = theme.palette;

    return (
        <Stack direction="row" spacing={6} alignItems="center" p={8}>

            <MarketplaceConnectorImage
                connector={connector}
                shape="rounded"
                size="large"
            />

            <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body2" color="text.secondary">Syncronize</Typography>
                <Icon icon="ArrowRight" fontSize="small" color="disabled" />
            </Stack>

            <Box
                sx={{
                    p: 1,
                    width: 96,
                    height: 96 * 0.5,
                    borderColor: colors.divider,
                    borderWidth: 1,
                    borderStyle: 'solid',
                    borderRadius: '6px',
                    bgcolor: 'background.paper',
                }}
            >
                <img

                    src={'/assets/images/ic_just_stock.png'}
                    alt="JustStock"
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
            </Box>

        </Stack>
    );

};

export default ConnectionSetupHeader;
